import { render, staticRenderFns } from "./list_advise.vue?vue&type=template&id=4a0b1cf4&scoped=true&"
import script from "./list_advise.vue?vue&type=script&lang=js&"
export * from "./list_advise.vue?vue&type=script&lang=js&"
import style0 from "./list_advise.vue?vue&type=style&index=0&id=4a0b1cf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b1cf4",
  null
  
)

export default component.exports